import { toast } from "sonner";
import { Save, RotateCcw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api, apiError } from "@/lib/api";

export const CONTACT_KEYS = ["contact_email", "phone_mx", "phone_intl", "phone_uk"];

export const ContactDefault = ({ tid, fieldKey, value, info, setInfo, setValue }) => {
  const cur = info[fieldKey] || {};
  const changed = (value || "").trim() && (value || "").trim() !== cur.current;
  const save = async () => {
    try { await api.put(`/docs/${tid}/contact/${fieldKey}`, { value: value.trim() }); setInfo({ ...info, [fieldKey]: { saved: true, current: value.trim() } }); toast.success("Guardado como predeterminado de esta plantilla"); }
    catch (e) { toast.error(apiError(e).message); }
  };
  const reset = async () => {
    try { const r = await api.delete(`/docs/${tid}/contact/${fieldKey}`); setInfo({ ...info, [fieldKey]: { saved: false, current: r.data.value } }); setValue(r.data.value); toast.success("Se restauró el valor original"); }
    catch (e) { toast.error(apiError(e).message); }
  };
  return (
    <div className="flex flex-wrap items-center gap-2 pt-1" data-testid={`contact-default-${fieldKey}`}>
      {changed && <Button type="button" size="sm" variant="outline" onClick={save} className="h-7 text-xs" data-testid={`contact-save-btn-${fieldKey}`}><Save size={13} className="mr-1" />Guardar como predeterminado</Button>}
      {cur.saved && <span className="text-[11px] font-medium text-violet-700" data-testid={`contact-saved-badge-${fieldKey}`}>Predeterminado guardado</span>}
      {cur.saved && <Button type="button" size="sm" variant="ghost" onClick={reset} className="h-7 text-xs" data-testid={`contact-reset-btn-${fieldKey}`}><RotateCcw size={13} className="mr-1" />Original</Button>}
    </div>
  );
};
